import { render } from "./Footer.vue?vue&type=template&id=201c1d88&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=201c1d88&lang=scss&scoped=true"

import exportComponent from "/workspace/hound-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-201c1d88"]])

export default __exports__